import { createReducer, on, StoreModule } from '@ngrx/store';
import { GroupRideHideOnMap, GroupRideShowOnMap } from './group-ride.actions';

export const groupRideFeatureKey = 'groupRideState';

export interface GroupRideState {
    groupRideId: string;
    showOnMap: boolean;
}

const initialState: GroupRideState = {
    groupRideId: '',
    showOnMap: false,
};

export const groupRideReducer = createReducer(
    initialState,
    on(GroupRideShowOnMap, (state, { groupRideId }) => {
        return { ...state, groupRideId, showOnMap: true };
    }),
    on(GroupRideHideOnMap, (state) => {
        return { ...state, groupRideId: '', showOnMap: false };
    })
);

export const groupRideStoreModule = StoreModule.forFeature(
    groupRideFeatureKey,
    groupRideReducer
);
